import { render, staticRenderFns } from "./rewardProActivity.vue?vue&type=template&id=fdc5fd9a"
import script from "./rewardProActivity.vue?vue&type=script&lang=js"
export * from "./rewardProActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports